import ArrowDownSvg from "../../assets/images/Arrow_Down.svg";
import "./ArrowDown.scss";

export default function ArrowDown(props) {
  return <img className="arrowDown" alt="" src={ArrowDownSvg} />;
}
